import React from 'react';
import PropTypes from 'prop-types';
import ErrorFallback from './errorFallback';

const CRASH_COUNT_KEY = 'app_crash_count';
const CRASH_TIME_KEY = 'app_crash_last_time';
const CRASH_WINDOW_MS = 60 * 1000; // treat crashes within 60s of each other as "repeated"

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    isRepeatedFailure: false,
  };

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error in ErrorBoundary:', error, errorInfo);

    let isRepeatedFailure = false;
    try {
      const now = Date.now();
      const lastCrashTime = parseInt(sessionStorage.getItem(CRASH_TIME_KEY) || '0', 10);
      const currentCount = parseInt(sessionStorage.getItem(CRASH_COUNT_KEY) || '0', 10);

      const isWithinWindow = lastCrashTime && (now - lastCrashTime) < CRASH_WINDOW_MS;
      const newCount = isWithinWindow ? currentCount + 1 : 1;

      sessionStorage.setItem(CRASH_COUNT_KEY, String(newCount));
      sessionStorage.setItem(CRASH_TIME_KEY, String(now));

      isRepeatedFailure = newCount > 1;
    } catch (e) {
      console.error('Error handling crash count in ErrorBoundary:', e);
    }

    this.setState({ isRepeatedFailure });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback isRepeatedFailure={this.state.isRepeatedFailure} />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;